import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_z962y8xcqr: FaireBrandEntity = {
  token: "b_z962y8xcqr",
  type: "brand",
  name: "Textile Graphix",
  avatarUrl:
    "https://cdn.faire.com/fastly/97a2ce1986e2ea3c728417dff097252820a11c8b70dddfb0c7b99d29d3f6ae7c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e3a530de96575e00a95593055a17acb0856f2c421ce3a8cdc25cfbc00c8e0538.png",
  logoUrl:
    "https://cdn.faire.com/fastly/97a2ce1986e2ea3c728417dff097252820a11c8b70dddfb0c7b99d29d3f6ae7c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e3a530de96575e00a95593055a17acb0856f2c421ce3a8cdc25cfbc00c8e0538.png",
  location: "Rexburg, ID, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "Crafted with youthful energy and a boundless love for creativity, Textile Graphix is not just a screenprinting enterprise; it's a canvas for innovation and artistic expression. Nestled at the outdoor heart of Idaho, our vibrant team is the lifeblood of our operation. Each member, fueled by a blend of ambition and passion for art, brings a unique perspective to the drawing table, ensuring that no two projects are ever the same.\n\nWe believe in breaking the mold. Our state-of-the-art screenprinting techniques are matched only by our zeal for pushing boundaries and exploring new horizons. Whether it's bold, intricate designs for apparel, bespoke merchandise for bands, or custom artwork for businesses, we tackle each project with an unmatched level of enthusiasm and a commitment to excellence.\n\nOur journey began with a simple vision: to revolutionize the screenprinting world through a blend of traditional craftsmanship and modern innovation. Today, that vision is alive and thriving, as we continue to captivate and inspire our clients with designs that speak volumes. \n\nJoin us on our journey. Whether you’re looking to bring your own vision to life or seeking inspiration for a new project, our doors are always open. Let’s create something unforgettable together.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:00.990Z",
    importedBy: "entity-db-cli",
  },
};
